export class StringUtils {
  static capitalize(text: string) {
    return text[0].toUpperCase() + String(text).slice(1)
  }
}
